/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { useMemo, useState } from 'react';
import {
  Controller, FormProvider, UseFormReturn
} from 'react-hook-form';
import Modal from 'react-modal';
import { useQuery } from 'react-query';
import { Image, Typography } from 'tfc-components';

import xacnhan from 'assets/images/xacnhan.png';
import Icon from 'components/atoms/Icon';
import Input from 'components/atoms/Input';
import Datepicker from 'components/molecules/DatePicker';
import Pulldown from 'components/molecules/Pulldown';
import useWindowDimensions from 'hooks/useWindowDemensions';
import { CheckInvitationData } from 'services/checkin/types';
import getAllProvinces from 'services/locations/types';

export type UserInfoType = {
  invitation_code?: string,
  full_name?: string,
  dob?: Date,
  phone: string,
  position_or_degree?: string,
  hospital?: string,
  department?: string,
  provinceCode?: OptionType,
  isRequireCme?: boolean,
  isRegistered?: boolean,
};

type Props = {
  method: UseFormReturn<UserInfoType>;
  handleConfirm?: () => void;
  isTemporary: boolean;
  infoUser?: CheckInvitationData;
};

const UserInfo: React.FC<Props> = ({
  method,
  handleConfirm,
  isTemporary,
  infoUser,
}) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [action, setAction] = useState<boolean>(false);
  const [checkedCondition, setCheckedCondition] = useState<boolean>(true);
  const { height } = useWindowDimensions();

  const handleSubmit = () => {
    if (!action) {
      setAction(true);
    }
    if (handleConfirm && checkedCondition) {
      handleConfirm();
    }
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
    if (!checkedCondition) {
      setCheckedCondition(true);
    }
  };

  const { data: provinceData, isLoading: provinceLoading } = useQuery(
    ['getAllProvincesMutate'],
    getAllProvinces,
  );

  const provinceOption: OptionType[] = useMemo(() => provinceData?.map((item) => ({
    label: item?.name || '',
    value: item?.code || '',
  })) || [], [provinceData]);

  return (
    <div className="p-userInfo_wrap">
      <div className="p-userInfo_form">
        <FormProvider {...method}>
          <Controller
            name="invitation_code"
            control={method.control}
            render={({ field, fieldState: { error } }) => (
              <div className="p-register_field">
                <Typography.Text
                  fontweight="600"
                  extendClasses="fs-26x36 color-antiFlashWhite p-register_field_fieldText"
                >
                  {`MÃ CME ${isTemporary ? '(TẠM)' : ''}`}
                </Typography.Text>
                <div className="p-register_field_input">
                  <Input
                    {...field}
                    readOnly={isTemporary}
                    disabled={!!infoUser}
                  />
                  {
                    error && (
                      <div className="p-register_error">
                        <Typography.Text
                          extendClasses="fs-18x26 p-register_error-text"
                          fontweight="600"
                        >
                          {error.message}
                        </Typography.Text>
                      </div>
                    )
                  }
                </div>
              </div>
            )}
          />
          <Controller
            name="full_name"
            control={method.control}
            render={({ field, fieldState: { error } }) => (
              <div className="p-register_field">
                <Typography.Text
                  fontweight="600"
                  extendClasses="fs-26x36 color-antiFlashWhite p-register_field_fieldText"
                >
                  HỌ VÀ TÊN
                </Typography.Text>
                <div className="p-register_field_input">
                  <Input
                    {...field}
                    disabled={!!infoUser}
                  />
                  {
                    error && (
                      <div className="p-register_error">
                        <Typography.Text
                          extendClasses="fs-18x26 p-register_error-text"
                          fontweight="600"
                        >
                          {error.message}
                        </Typography.Text>
                      </div>
                    )
                  }
                </div>
              </div>
            )}
          />
          <Controller
            name="phone"
            control={method.control}
            render={({ field, fieldState: { error } }) => (
              <div className="p-register_field">
                <Typography.Text
                  fontweight="600"
                  extendClasses="fs-26x36 color-antiFlashWhite p-register_field_fieldText"
                >
                  SỐ ĐIỆN THOẠI
                </Typography.Text>
                <div className="p-register_field_input">
                  <Input
                    {...field}
                    disabled={!!infoUser}
                  />
                  {
                    error && (
                      <div className="p-register_error">
                        <Typography.Text
                          extendClasses="fs-18x26 p-register_error-text"
                          fontweight="600"
                        >
                          {error.message}
                        </Typography.Text>
                      </div>
                    )
                  }
                </div>
              </div>
            )}
          />
          <Controller
            name="position_or_degree"
            control={method.control}
            render={({ field, fieldState: { error } }) => (
              <div className="p-register_field">
                <Typography.Text
                  fontweight="600"
                  extendClasses="fs-26x36 color-antiFlashWhite p-register_field_fieldText"
                >
                  HỌC HÀM / HỌC VỊ
                </Typography.Text>
                <div className="p-register_field_input">
                  <Input
                    {...field}
                    disabled={!!infoUser}
                  />
                  {
                    error && (
                      <div className="p-register_error">
                        <Typography.Text
                          extendClasses="fs-18x26 p-register_error-text"
                          fontweight="600"
                        >
                          {error.message}
                        </Typography.Text>
                      </div>
                    )
                  }
                </div>
              </div>
            )}
          />
          <Controller
            name="dob"
            control={method.control}
            render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
              <div className="p-register_field">
                <Typography.Text
                  fontweight="600"
                  extendClasses="fs-26x36 color-antiFlashWhite p-register_field_fieldText"
                >
                  NGÀY SINH
                </Typography.Text>
                <div className="p-register_field_input">
                  <Datepicker
                    id=""
                    startDate={value ? new Date(value) : undefined}
                    handleChangeDate={onChange}
                    placeholder={!infoUser ? 'DD/MM/YYYY' : ''}
                    error={error?.message}
                    innerRef={ref}
                    modifiers="infoModal"
                    disabled={!!infoUser}
                  />
                  {
                    error && (
                      <div className="p-register_error">
                        <Typography.Text
                          extendClasses="fs-18x26 p-register_error-text"
                          fontweight="600"
                        >
                          {error.message}
                        </Typography.Text>
                      </div>
                    )
                  }
                </div>
              </div>
            )}
          />
          <Controller
            name="hospital"
            control={method.control}
            render={({ field, fieldState: { error } }) => (
              <div className="p-register_field">
                <Typography.Text
                  fontweight="600"
                  extendClasses="fs-26x36 color-antiFlashWhite p-register_field_fieldText"
                >
                  BỆNH VIỆN
                </Typography.Text>
                <div className="p-register_field_input">
                  <Input
                    {...field}
                    disabled={!!infoUser}
                  />
                  {
                    error && (
                      <div className="p-register_error">
                        <Typography.Text
                          extendClasses="fs-18x26 p-register_error-text"
                          fontweight="600"
                        >
                          {error.message}
                        </Typography.Text>
                      </div>
                    )
                  }
                </div>
              </div>
            )}
          />
          <Controller
            name="department"
            control={method.control}
            render={({ field, fieldState: { error } }) => (
              <div className="p-register_field">
                <Typography.Text
                  fontweight="600"
                  extendClasses="fs-26x36 color-antiFlashWhite p-register_field_fieldText"
                >
                  KHOA PHÒNG
                </Typography.Text>
                <div className="p-register_field_input">
                  <Input
                    {...field}
                    disabled={!!infoUser}
                  />
                  {
                    error && (
                      <div className="p-register_error">
                        <Typography.Text
                          extendClasses="fs-18x26 p-register_error-text"
                          fontweight="600"
                        >
                          {error.message}
                        </Typography.Text>
                      </div>
                    )
                  }
                </div>
              </div>
            )}
          />
          <Controller
            name="provinceCode"
            control={method.control}
            render={({ field, fieldState: { error } }) => (
              <div className="p-register_field">
                <Typography.Text
                  fontweight="600"
                  extendClasses="fs-26x36 color-antiFlashWhite p-register_field_fieldText"
                >
                  TỈNH THÀNH
                </Typography.Text>
                <div className="p-register_field_input">
                  <Pulldown
                    {...field}
                    name="provinceCode"
                    placeholder={!infoUser ? 'Chọn tỉnh/thành' : ''}
                    handleChange={field.onChange}
                    options={provinceOption}
                    loading={provinceLoading}
                    error={!!error?.message}
                    isDisabled={!!infoUser}
                  />
                  {
                    error && (
                      <div className="p-register_error">
                        <Typography.Text
                          extendClasses="fs-18x26 p-register_error-text"
                          fontweight="600"
                        >
                          {error.message}
                        </Typography.Text>
                      </div>
                    )
                  }
                </div>
              </div>
            )}
          />
        </FormProvider>
      </div>
      <div className="p-userInfo_conditionWrap">
        <div
          className="p-userInfo_condition"
          onClick={() => setCheckedCondition(!checkedCondition)}
        >
          {checkedCondition && <Icon iconName="check" size="38" />}
        </div>
        <div className="p-userInfo_termsTextWrap">
          <span
            className="p-userInfo_termsText fs-26x36 color-antiFlashWhite"
            onClick={() => setCheckedCondition(!checkedCondition)}
          >
            Tôi đồng ý các&nbsp;
          </span>
          <span
            className="p-userInfo_termsText fs-26x36 color-antiFlashWhite"
            onClick={() => setIsOpenModal(true)}
            style={{ textDecoration: 'underline' }}
          >
            điều khoản và điều kiện
          </span>
          <span
            className="p-userInfo_termsText fs-26x36 color-antiFlashWhite"
            onClick={() => setCheckedCondition(!checkedCondition)}
          >
            &nbsp;của công ty Abbott
          </span>
        </div>
      </div>

      {!checkedCondition && action && (
        <Typography.Text
          textStyle="center"
          extendClasses="p-userInfo_termsText-error fs-18x26"
          fontweight="400"
        >
          Vui lòng xác nhận để tiếp tục
        </Typography.Text>
      )}
      <div
        className="p-userInfo_confirmButton"
        onClick={method.handleSubmit(handleSubmit)}
      >
        <Image
          imgSrc={xacnhan}
          alt="checkBtn"
          ratio={600 / 109}
        />
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isOpenModal}
        style={{
          content: {
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            border: 'none',
            background: 'none',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '0',
            outline: 'none',
            padding: '0',
          },
        }}
      >
        <div
          style={{ height: `${height - 180}px` }}
          className="p-userInfo_modal"
        >
          <Typography.Heading
            textStyle="center"
            extendClasses="fs-36x54"
            fontweight="600"
          >
            ĐIỀU KHOẢN LƯU TRỮ THÔNG TIN
          </Typography.Heading>
          <div className="p-userInfo_modal_content">
            <Typography.Text
              extendClasses="fs-16x28"
            >
              Bằng việc truy cập vào trang web đăng ký thành viên, cung cấp thông tin cá nhân cơ bản và thông tin cá nhân nhạy cảm trên website và/hoặc bấm vào nút
              {' '}
              <b>"Tôi đã đọc và đồng ý với các điều khoản và điều kiện"</b>
              , bạn xác nhận mình đã đọc và hiểu Chính sách quyền riêng tư của Abbott tại https://www.vn.abbott/privacy-policy.html và cho phép [Công Ty TNHH Dinh Dưỡng 3A (Việt Nam) và Văn Phòng Đại Diện Abbott Laboratories GmBH Tại Thành Phố Hồ Chí Minh]
              {' '}
              <b>("Abbott")</b>
              {' '}
              xử lý toàn bộ các thông tin cá nhân này, bao gồm nhưng không giới hạn ở việc thu thập, ghi, phân tích, xác nhận, lưu trữ, chỉnh sửa, công khai, kết hợp, tích hợp, truy cập, truy xuất, thu hồi, mã hóa, giải mã, sao chép, xóa, hủy, chia sẻ, truyền đưa, cung cấp, chuyển giao cho các công ty trong cùng tập đoàn Abbott và/hoặc các nhà cung cấp dịch vụ bên thứ ba được chỉ định, trong hoặc ngoài lãnh thổ Việt Nam, và xử lý thông tin cá nhân bằng phương tiện tự động, nhằm mục đích lập danh sách khách hàng / tiến hành khảo sát/ tiếp nhận, quản lý và hỗ trợ khách hàng / chương trình khách hàng thân thiết/ thống kê/ đánh giá/ tuân thủ với quy định pháp luật, ví dụ như đăng ký khuyến mại/ tư vấn chăm sóc sức khỏe dinh dưỡng và/hoặc cung cấp thông tin (thông tin về các sự kiện, lời mời tham dự hội thảo, thông tin nghiên cứu khoa học, kiến thức chăm sóc sức khỏe, thông tin sản phẩm, khuyến mại, sự kiện và thông tin tiếp thị và phi tiếp thị khác) / cung cấp khuyến mại / ký kết và thực hiện hợp đồng / thực hiện thanh toán], phục vụ quá trình giải quyết tranh chấp, khiếu nại, tuân thủ các quy định pháp luật liên quan, tập hợp dữ liệu từ các nguồn khác nhau vào cơ sở dữ liệu tập trung, và thực hiện các biện pháp bảo vệ thông tin cá nhân của bạn, tùy trường hợp cần thiết. Abbott cam kết đảm bảo các biện pháp quản lý và kỹ thuật cần thiết để bảo vệ thông tin cá nhân mà bạn cung cấp, phù hợp với Chính sách quyền riêng tư của Abbott và pháp luật Việt Nam. Việc xử lý dữ liệu sẽ được bắt đầu kể từ thời điểm Abbott nhận được dữ liệu cá nhân và sự đồng ý của bạn cho việc xử lý dữ liệu cá nhân đó. Sự đồng ý của bạn có hiệu lực cho tới khi bạn có quyết định khác.
              <br />
              <br />
              Bạn có quyền: yêu cầu chỉnh sửa, rút lại sự đồng ý, xóa, hạn chế,
              yêu cầu cung cấp dữ liệu cá nhân của mình. Bạn có nghĩa vụ:
              Tự bảo vệ; cung cấp đầy đủ, chính xác dữ liệu cá nhân của mình.
              <br />
              <br />
              Để thực hiện các quyền trên, vui lòng liên hệ số điện thoại
              {' '}
              <a href="tel:19001519" style={{ color: 'white', fontWeight: '600' }}>1900 1519</a>
              .
              <br />
              <br />
              Bằng việc truy cập vào trang web đăng ký thành viên, cung cấp thông tin cá nhân cơ bản và thông tin cá nhân nhạy cảm trên website và/hoặc bấm vào nút
              {' '}
              <b>"Tôi đã đọc và đồng ý với các điều khoản và điều kiện"</b>
              , bạn xác nhận mình đã đọc và hiểu Chính sách quyền riêng tư của Abbott tại https://www.vn.abbott/privacy-policy.html và cho phép [Công Ty TNHH Dinh Dưỡng 3A (Việt Nam) và Văn Phòng Đại Diện Abbott Laboratories GmBH Tại Thành Phố Hồ Chí Minh]
              {' '}
              <b>("Abbott")</b>
              {' '}
              và Công ty cổ phần công nghệ Haravan xử lý toàn bộ các thông tin cá nhân này, bao gồm nhưng không giới hạn ở việc thu thập, ghi, phân tích, xác nhận, lưu trữ, chỉnh sửa, công khai, kết hợp, tích hợp, truy cập, truy xuất, thu hồi, mã hóa, giải mã, sao chép, xóa, hủy, chia sẻ, truyền đưa, cung cấp, chuyển giao cho các công ty trong cùng tập đoàn Abbott và/hoặc các nhà cung cấp dịch vụ bên thứ ba được chỉ định, trong hoặc ngoài lãnh thổ Việt Nam, và xử lý thông tin cá nhân bằng phương tiện tự động, nhằm mục đích lập danh sách khách hàng / tiến hành khảo sát/ tiếp nhận, quản lý và hỗ trợ khách hàng / chương trình khách hàng thân thiết/ thống kê/ đánh giá/ tuân thủ với quy định pháp luật, ví dụ như đăng ký khuyến mại/ tư vấn chăm sóc sức khỏe dinh dưỡng và/hoặc cung cấp thông tin (thông tin về các sự kiện, lời mời tham dự hội thảo, thông tin nghiên cứu khoa học, kiến thức chăm sóc sức khỏe, thông tin sản phẩm, khuyến mại, sự kiện và thông tin tiếp thị và phi tiếp thị khác) / cung cấp khuyến mại / ký kết và thực hiện hợp đồng / thực hiện thanh toán], phục vụ quá trình giải quyết tranh chấp, khiếu nại, tuân thủ các quy định pháp luật liên quan, tập hợp dữ liệu từ các nguồn khác nhau vào cơ sở dữ liệu tập trung, và thực hiện các biện pháp bảo vệ thông tin cá nhân của bạn, tùy trường hợp cần thiết. Abbott cam kết đảm bảo các biện pháp quản lý và kỹ thuật cần thiết để bảo vệ thông tin cá nhân mà bạn cung cấp, phù hợp với Chính sách quyền riêng tư của Abbott và pháp luật Việt Nam. Việc xử lý dữ liệu sẽ được bắt đầu kể từ thời điểm Abbott nhận được dữ liệu cá nhân và sự đồng ý của bạn cho việc xử lý dữ liệu cá nhân đó. Sự đồng ý của bạn có hiệu lực cho tới khi bạn có quyết định khác.
              <br />
              <br />
              Bạn có quyền: yêu cầu chỉnh sửa, rút lại sự đồng ý, xóa,
              hạn chế, yêu cầu cung cấp dữ liệu cá nhân của mình.
              Bạn có nghĩa vụ: Tự bảo vệ; cung cấp đầy đủ, chính xác dữ liệu cá nhân của mình.
              <br />
              <br />
              Để thực hiện các quyền trên, vui lòng liên hệ số điện thoại
              {' '}
              <a href="tel:19001519" style={{ color: 'white', fontWeight: '600' }}>1900 1519</a>
              .
            </Typography.Text>
          </div>
        </div>
        <div
          onClick={handleCloseModal}
          className="p-userInfo_modal_completeButton"
        >
          <Image
            imgSrc={xacnhan}
            alt="completeBtn"
            ratio={600 / 109}
          />
        </div>
      </Modal>
    </div>
  );
};

export default UserInfo;
